<template>
    <el-form >
            <el-col :span="24">
                <el-table :data="app_data"  style="width: 100%" height="100%" @cell-mouse-enter="displayOrder" :cell-style="setCellStyle">
                    <el-table-column fixed prop="app_id" label="序号" >
                    </el-table-column>
                    <el-table-column prop="app_name" label="应用名称">
                    </el-table-column>
                    <el-table-column  label="排序"  >
                        <template slot-scope="scope">
                            <span>↓</span><span>↑</span>
                        </template>
                    </el-table-column>
                    <el-table-column  label="推荐" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.is_recommend" style="height:30px" @change="handleSubmitAppBind"></el-switch>
                    </template>
                    </el-table-column>
                </el-table>
            </el-col>
    </el-form>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>

<script>
export default {
    data() {
        return {
            formLabelWidth:'120px',
        };
    },
    props:{
            params:{
                type:Array,
                required:false
            },
            app_data:{
                type:Array,
                required:false
            }
    },
    mounted(){
        if(this.params != null){
            let appid = this.params.map((item,index,arr) => {
                return parseInt(item.app_id)
            }) 
            this.app_data.forEach((item,index)=>{
                if(appid.indexOf(item.app_id) != -1){
                    this.app_data[index].is_recommend = true;
                }
            });
        }
        
    },
    methods:{
        displayOrder(row,column,cell,event){
        },
        
        setCellStyle(Object){
        },

        handleSubmitAppBind(){
            let  result = this.app_data.filter(item=>{
                    return item.is_recommend == true;
                })
            this.$emit('handleSubmitAppBind',result);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/jiaoben/appBind.vue